"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateUserDto = instanceOfUpdateUserDto;
exports.UpdateUserDtoFromJSON = UpdateUserDtoFromJSON;
exports.UpdateUserDtoFromJSONTyped = UpdateUserDtoFromJSONTyped;
exports.UpdateUserDtoToJSON = UpdateUserDtoToJSON;
exports.UpdateUserDtoToJSONTyped = UpdateUserDtoToJSONTyped;
/**
 * Check if a given object implements the UpdateUserDto interface.
 */
function instanceOfUpdateUserDto(value) {
    return true;
}
function UpdateUserDtoFromJSON(json) {
    return UpdateUserDtoFromJSONTyped(json, false);
}
function UpdateUserDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'profilePhotoId': json['profilePhotoId'] == null ? undefined : json['profilePhotoId'],
    };
}
function UpdateUserDtoToJSON(json) {
    return UpdateUserDtoToJSONTyped(json, false);
}
function UpdateUserDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'profilePhotoId': value['profilePhotoId'],
    };
}
